/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Descriptionshtml4Inputs */

const en__field_descriptionshtml4 = /** @type {(inputs: _Field_Descriptionshtml4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de__field_descriptionshtml4 = /** @type {(inputs: _Field_Descriptionshtml4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {_Field_Descriptionshtml4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_descriptionshtml4 = /** @type {((inputs?: _Field_Descriptionshtml4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Descriptionshtml4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_descriptionshtml4(inputs)
	return de__field_descriptionshtml4(inputs)
});
export { _field_descriptionshtml4 as "_field_descriptionsHTML" }